module.exports = __webpack_public_path__ + "static/img/evaluation_MBTI_1.4f14dd17.jpg";